/* ───────────────────────────────────────────────────────────── */
/* UMM SKINCARE - CUSTOM JAVASCRIPT */
/* Based on SHOPIFY_LIQUID_HANDOFF.md specifications */
/* ───────────────────────────────────────────────────────────── */

// ───────────────────────────────────────────────────────────
// SCROLL REVEAL
// ───────────────────────────────────────────────────────────

const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('umm-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.12 }
);

const initRevealAnimations = (scope = document) => {
  scope.querySelectorAll('.umm-reveal').forEach((el) => {
    revealObserver.observe(el);
  });
};

initRevealAnimations();

// ───────────────────────────────────────────────────────────
// NAVIGATION SCROLL STATE
// ───────────────────────────────────────────────────────────

const nav = document.getElementById('umm-nav');

window.addEventListener('scroll', () => {
  if (!nav) return;

  if (window.scrollY > 60) {
    nav.classList.add('scrolled');
  } else {
    nav.classList.remove('scrolled');
  }
}, { passive: true });

// ───────────────────────────────────────────────────────────
// SMOOTH SCROLL LINKS (optional)
// ───────────────────────────────────────────────────────────

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const href = this.getAttribute('href');
    if (href === '#') return;

    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

document.addEventListener('shopify:section:load', (event) => {
  if (!event.target) return;
  initRevealAnimations(event.target);
});
